import { render, staticRenderFns } from "./CellBox.vue?vue&type=template&id=2380a2f8&scoped=true&"
import script from "./CellBox.vue?vue&type=script&lang=js&"
export * from "./CellBox.vue?vue&type=script&lang=js&"
import style0 from "./CellBox.vue?vue&type=style&index=0&id=2380a2f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2380a2f8",
  null
  
)

export default component.exports